module.exports = __webpack_public_path__ + "img/product2880p13.4be4a59e.png";